var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useFormik } from 'formik';
import { format, add as dateAdd } from 'date-fns';
import { CircularProgress, Grid } from '@mui/material';
import { useRequest } from '../../../hooks/requestHook';
import { monthlyClosing as api } from '../../../api';
import { camelize } from '../../../utils/camelize';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { FormikSelectField } from '../../atoms/SelectField';
import FormikDatePicker from '../../atoms/FormikDatePicker';
import { useNotify } from '../../../hooks/notificationHook';
var yearItems = [];
for (var y = 2021; y < 2100; y += 1) {
    yearItems.push({ text: "".concat(y), value: "".concat(y) });
}
var monthItems = [];
for (var m = 1; m <= 12; m += 1) {
    monthItems.push({ text: "".concat(m), value: "".concat(m) });
}
var REQUIRED_FIELDS = [
    'year',
    'month',
    'created_date',
    'expired_date',
];
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"], ["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"])));
var MonthlyClosingForm = function (_a) {
    var onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var createMonthlyClosing = useRequest(api.create);
    var destoryMonthlyClosing = useRequest(api.destroy);
    var getMonthlyClosing = useRequest(api.get);
    var notify = useNotify();
    var handleSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response, timer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values.created_date || !values.expired_date)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, createMonthlyClosing({
                            monthly_closing: {
                                year: values.year,
                                month: values.month,
                                created_date: values.created_date,
                                expired_date: values.expired_date,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    timer = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
                        var monthlyClosing;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getMonthlyClosing(response.id)];
                                case 1:
                                    monthlyClosing = _a.sent();
                                    if (monthlyClosing && !monthlyClosing.processing) {
                                        if (monthlyClosing.error) {
                                            notify('error', [monthlyClosing.error]);
                                            destoryMonthlyClosing(response.id);
                                            setLoading(false);
                                        }
                                        else {
                                            onSubmit(monthlyClosing);
                                        }
                                        clearInterval(timer);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }, 3000);
                    return [2 /*return*/];
            }
        });
    }); }, [
        createMonthlyClosing,
        getMonthlyClosing,
        onSubmit,
        notify,
        destoryMonthlyClosing,
    ]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.monthlyClosing.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var lastMonth = dateAdd(new Date(), { months: -1 });
    var formik = useFormik({
        initialValues: {
            year: format(lastMonth, 'yyyy'),
            month: format(lastMonth, 'M'),
            created_date: format(new Date(), 'yyyy-MM-dd'),
            expired_date: '',
        },
        onSubmit: handleSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validateOnBlur: true,
        validate: validate,
    });
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(GridContainer, { container: true, spacing: 4 },
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikSelectField, { fullWidth: true, label: t('params.monthlyClosing.year'), name: "year", items: yearItems, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikSelectField, { fullWidth: true, label: t('params.monthlyClosing.month'), name: "month", items: monthItems, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "created_date", label: t('params.monthlyClosing.createdDate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikDatePicker, { fullWidth: true, name: "expired_date", label: t('params.monthlyClosing.expiredDate'), required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12 }, loading ? (React.createElement(PageSubmitButton, { disabled: true },
                React.createElement(CircularProgress, { size: 16 }),
                t('buttons.processing'))) : (React.createElement(PageSubmitButton, { disabled: !formik.isValid }, t('buttons.create')))))));
};
export default MonthlyClosingForm;
var templateObject_1;
